import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  EcommerceExternalPricing,
  PaymentIntentExternalApportionOption,
  SearchEngineProduct,
  ShoppingCart,
  ShoppingCartItem,
} from '../../models';
import { ShoppingCartsServiceApi } from './shopping-carts.service.api';
import { ShoppingCartsServiceMock } from './shopping-carts.service.mock';

export interface ShoppingCartItemProduct extends ShoppingCartItem {
  resource: SearchEngineProduct | null;
}

export type ShoppingCartDetail = Omit<ShoppingCart, 'createdAt' | 'id' | 'items' | 'updatedAt' | 'userId'> & ({
  discounts: number;
  items: ShoppingCartItemProduct[];
  originalShippingCost: number;
  pricing: Record<PaymentIntentExternalApportionOption, EcommerceExternalPricing>;
  shippingCost: number;
  subtotal: number;
  total: number;
  totalItems: number;
});

export type LocalShoppingCart = Omit<ShoppingCart, 'createdAt' | 'id' | 'updatedAt' | 'userId'>;
export type AddShoppingCartItemData = Pick<ShoppingCartItem, 'quantity' | 'resourceId' | 'resourceType'>;
export interface RemoveShoppingCartItemData {
  quantity: number;
  resourceId: string;
  resourceType: 'product';
}

export interface SynchronizeShoppingCartData {
  currency: string;
  items: {
    addedAt: Date;
    quantity: number;
    resourceId: string;
    resourceType: 'product';
  }[];
}

@Injectable({
  providedIn: 'root',
  useClass: environment.usingMocks ? ShoppingCartsServiceMock : ShoppingCartsServiceApi,
})
export abstract class ShoppingCartsService {
  abstract addItem(data: AddShoppingCartItemData): Promise<void>;
  abstract get(): Observable<ShoppingCartDetail | null>;
  abstract removeItem(data: RemoveShoppingCartItemData): Promise<void>;
  abstract synchronize(): Promise<void>;
  abstract updateShippingAddress(shippingAddressId: string): Promise<void>;
}
